import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("As senhas não coincidem");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-nx-dark bg-grid flex items-center justify-center px-6 font-jakarta" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <div className="glass rounded-3xl p-8">
          <h1 className="font-syne text-2xl font-bold text-white">Definir nova senha</h1>
          {!token ? (
            <p className="mt-5 text-sm text-red-400" data-testid="reset-invalid-token">
              Link inválido. Solicite uma nova redefinição de senha.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-5">
              <div>
                <label htmlFor="new-password" className="text-xs font-mono uppercase tracking-widest text-zinc-400">Nova senha</label>
                <input
                  id="new-password"
                  type="password"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password-input"
                  className="mt-2 w-full bg-zinc-900/80 border border-zinc-700 focus:border-nx-yellow focus:outline-none rounded-xl px-4 py-3 text-sm text-white transition-colors"
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
              <div>
                <label htmlFor="confirm-password" className="text-xs font-mono uppercase tracking-widest text-zinc-400">Confirmar senha</label>
                <input
                  id="confirm-password"
                  type="password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-confirm-input"
                  className="mt-2 w-full bg-zinc-900/80 border border-zinc-700 focus:border-nx-yellow focus:outline-none rounded-xl px-4 py-3 text-sm text-white transition-colors"
                  placeholder="Repita a senha"
                />
              </div>
              {error && <p className="text-sm text-red-400" data-testid="reset-error">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                data-testid="reset-submit-button"
                className="w-full bg-nx-yellow text-nx-dark font-bold py-3.5 rounded-xl hover:bg-nx-electric transition-colors disabled:opacity-50"
              >
                {loading ? "Salvando..." : "Redefinir senha"}
              </button>
            </form>
          )}
          <Link to="/login" className="block mt-6 text-xs text-nx-yellow hover:underline font-semibold" data-testid="reset-back-to-login">
            ← Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
}
